import React from "react";
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';


class Old extends React.Component {
  componentDidMount(){
    this.timeout = window.setTimeout(() => {
      this.props.changeRoute("/");
    }, 5000);
  }
  componentWillUnmount(){
    if(this.timeout != null){
      window.clearTimeout(this.timeout);
    }
  }
  render(){
    return (
    <div>
      <h1>
        This is an old enpoint, you will be automatically redirected to home..
      </h1>
    </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
    changeRoute: (url) => dispatch(push(url)),
  };
}

const mapStateToProps = createStructuredSelector({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Old);


// WEBPACK FOOTER //
// ./src/containers/App/old.js